<template>
  <div class="album-wrapper">
    <div class="container">
      <div>
        <button class="button-primary mb-10 mr-10" @click="$router.push(`/albums/${id}/upload`)">
          Upload Image
        </button>

        <button class="button-secondary" @click="$router.back()">
          <span>
            Back
          </span>
        </button>
      </div>

      <div class="album-page-container">
        <div class="album-main-content">
          <div class="card w-100">

            <h3 v-if="album">Album: {{ album.album_name }}</h3>

            <div class="image-display" v-if="album && album.images.length > 0">
              <RowImageDisplay v-for="image in album.images" :key="image.id" :image-url="image.path"
                               :title="image.image_name" :description="image.description" :image_id="image.id"
                               :album_id="id"
                               :publication-date="image.publication_date" :views="image.views"
                               :published="image.published"
                               :reviewed="image.reviewed"
                               :allowed_by_moderator="image.allowed_by_moderator"
                               @deleteImage="removeImageFromImages(image.id)"/>
            </div>
            <div v-if="album && album.images.length == 0" class="no-images-container">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                   class="bi bi-images" viewBox="0 0 16 16">
                <path d="M4.502 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"/>
                <path
                    d="M14.002 13a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2V5A2 2 0 0 1 2 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-1.998 2M14 2H4a1 1 0 0 0-1 1h9.002a2 2 0 0 1 2 2v7A1 1 0 0 0 15 11V3a1 1 0 0 0-1-1M2.002 4a1 1 0 0 0-1 1v8l2.646-2.354a.5.5 0 0 1 .63-.062l2.66 1.773 3.71-3.71a.5.5 0 0 1 .577-.094l1.777 1.947V5a1 1 0 0 0-1-1z"/>
              </svg>
              <p>No images found. Add some!</p>
            </div>

          </div>
        </div>

        <div class="album-sidebar">
          <div class="card w-100">
            <h3>Stats</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {onMounted, ref} from 'vue';
import RowImageDisplay from '../common/RowImageDisplay.vue';
import apiService from '@/services/apiService';

const {id} = defineProps({
  id: String,
})

const album = ref(null);

onMounted(async () => {
  const result = await apiService.getAlbumById(id)

  if (result?.images) {
    result.images = result.images.map(image => ({
      ...image,
      publication_date: image.publication_date
          ? new Date(image.publication_date)
          : null
    }))
  }

  album.value = result
})

function removeImageFromImages(image_id){
  album.value.images = album.value.images.filter(image => image.id !== image_id)
}

</script>

<style scoped>

.album-wrapper {
  min-height: 100vh;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1.5rem;
  color: #323232;
}

.album-page-container {
  display: flex;
  height: 100%;
  width: 100%;
  align-items: start;
  justify-content: start;
}

.album-main-content {
  width: 70%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-right: 1rem;
}

.album-sidebar {
  width: 30%;
}

.image-display {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
}

.no-images-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  color: gray;
}
</style>